import { UserEnum } from '../enum/user';
const Ajax = (method, url, data, option) => {
    // @ts-ignore
    const userInfo = uni.getStorageSync(UserEnum.USERINFO);
    // 默认的设置的请求头
    let token = '';
    if (userInfo && (userInfo.token || userInfo.Token)) {
        token = userInfo.token || userInfo.Token;
    }
    const ajaxHeader = {
        'Authorization': `Bearer ${token}` || '',
        "tokenType": 'jrzz',
    };
    const optData = {
        url,
        method,
        data: data || {},
        headers: option.headers ? Object.assign(ajaxHeader, option.headers) : ajaxHeader,
    };
    return new Promise((resolve, reject) => {
        // @ts-ignore
        uni.request({
            url: optData.url,
            data: optData.data,
            method: optData.method,
            header: optData.headers,
            success: (response) => {
                // @ts-ignore
                uni.hideLoading();
                resolve(response.data);
            },
            fail: (res) => {
                // @ts-ignore
                uni.hideLoading();
                reject(res.data || res);
            }
        });
    });
};
export class UniDataService {
    static async get(url = '', data = {}, option = {}) {
        return await Ajax('get', url, data, option);
    }
    static async post(url = '', data = {}, option = {}) {
        return await Ajax('post', url, data, option);
    }
}
;
